import * as React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core"
import { forwardRef } from "react";


export const YoutubeIcon: React.FC<SvgIconProps> = forwardRef(({...props}, ref) => {
  return (
    <SvgIcon {...props} viewBox="0 0 21 14" innerRef={ref} data-name="telegram">
      <path d="M10.4753 13.9817L6.37209 13.9057C5.04356 13.8793 3.71172 13.9321 2.40923 13.6579C0.427855 13.2483 0.287487 11.2399 0.140607 9.55526C-0.0617793 7.18684 0.0165703 4.77543 0.398499 2.42677C0.61411 1.10893 1.46263 0.322568 2.77483 0.236997C7.20448 -0.0735544 11.6636 -0.0367508 16.0834 0.108133C16.5502 0.121414 17.0202 0.194008 17.4805 0.276639C19.7525 0.679657 19.8079 2.95561 19.9552 4.87154C20.1021 6.80724 20.0401 8.75288 19.7593 10.6754C19.5341 12.2672 19.1032 13.6021 17.2846 13.7309C15.0061 13.8994 12.7798 14.0351 10.4949 13.9919C10.495 13.9817 10.4818 13.9817 10.4753 13.9817ZM8.06301 9.95169C9.78009 8.95403 11.4644 7.973 13.1717 6.98204C11.4514 5.98438 9.77027 5.00335 8.06301 4.01238V9.95169Z" fill="currentColor"/>
    </SvgIcon>
  );
})

export default YoutubeIcon;